import type { RouteRecordRaw } from 'vue-router'

const memberRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: 'Home',
      show_on_sidenav: true,
      must_authenticate: false,
      icon: 'home-outline',
    },
    component: () =>
      import(/* webpackChunkName: "home" */ '../../views/HomePage.vue'),
  },
  {
    path: '/hub',
    redirect: '/',
  },
  {
    path: '/apps',
    name: 'apps',
    meta: {
      title: 'Apps',
      show_on_sidenav: true,
      must_authenticate: true,
      icon: 'dots-grid',
    },
    component: () =>
      import(/* webpackChunkName: "apps" */ '../../views/LabourAppPage.vue'),
  },
  {
    path: '/events',
    name: 'events',
    meta: {
      title: 'Events',
      show_on_sidenav: true,
      must_authenticate: true,
      icon: 'calendar-blank-outline',
    },
    component: () =>
      import(/* webpackChunkName: "events" */ '../../views/EventsPage.vue'),
  },
  {
    path: '/local-party',
    name: 'local-party',
    meta: {
      title: 'Local Party',
      show_on_sidenav: true,
      must_authenticate: true,
      icon: 'map-marker-outline',
    },
    component: () =>
      import(/* webpackChunkName: "local-party" */ '../../views/AreaPage.vue'),
  },
  {
    path: '/profile',
    name: 'profile',
    meta: {
      title: 'Member Profile',
      show_on_sidenav: true,
      must_authenticate: true,
      icon: 'account-outline',
    },
    component: () =>
      import(/* webpackChunkName: "profile" */ '../../views/ProfilePage.vue'),
  },
]

export default memberRoutes
